import { Link } from "react-router-dom";
import { AddToCartButton, ViewDetails } from "../../../../../../constants";
import { useAppDispatch } from "../../../../../../reduxToolkit/hooks";
import { addToCartData } from "../../../../../../reduxToolkit/reducers/eCommerce/cartSlice";
import { ButtonsProps, ProductItems } from "../../../../../../types/Ecommerce";
import { routes } from "../../../../../../routers/routes";

// This component displays buttons for adding products to cart and viewing the product details.
const Buttons: React.FC<ButtonsProps> = ({ singleProduct, quantity }) => {

  const dispatch = useAppDispatch();
  const AddToCarts = (item: ProductItems) => dispatch(addToCartData({ item, quantity }));

  return (
    <div>
      <Link to={routes.ECommerce.Cart} className="btn btn-primary text-white me-2" onClick={() => AddToCarts(singleProduct)}>
        {AddToCartButton}
      </Link>
      <Link to={routes.ECommerce.ProductPage} className="btn btn-primary text-white">
        {ViewDetails}
      </Link>
    </div>
  );
};
export default Buttons;